import { render, staticRenderFns } from "./ProjectReadOnlyTimetableView.vue?vue&type=template&id=b7516bba&scoped=true&"
import script from "./ProjectReadOnlyTimetableView.vue?vue&type=script&lang=js&"
export * from "./ProjectReadOnlyTimetableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7516bba",
  null
  
)

export default component.exports